import {UnitRatingRequest} from './unit-rating-request';
import {UnitRatingResponse} from './unit-rating-response';

export class RatingUnit {

  id!: number;
  personId!: string;
  orgUnitId!: string;
  productId!: string;
  modelCode!: string;
  sizeCode!: string;
  systemTypeCode!: string;
  coilRowCode!: string;
  powerSupplyCode!: string;
  motorTypeCode!: string;
  airFilterCode!: string;
  electricHeatCode!: string;
  requestId!: number;
  responseId!: number;
  request!: UnitRatingRequest;
  response!: UnitRatingResponse;
  notes!: string;
  sequence!: number;
  primaryCoilCircuits!: string;
  secondaryCoilCircuits!: string;

}
